<div class="eService-panel">
    <div class="eService-panel-row">
        <h1 class="service_details_title new22"> {{item.name}} &nbsp;</h1>


        <div class="hidden-xs">

            <span style="display: none;" id="serviceURL">
                <a
                    href="https://eservices.zatca.gov.sa/sites/sc/ar/gebaya/Pages/default.aspx">https://eservices.zatca.gov.sa/sites/sc/ar/gebaya/Pages/default.aspx</a>
            </span>
        </div>
    </div>



    <div class="serviceTaxTypes">
        <div [routerLink]="'/all-data-view'" [queryParams]="{id: item.ministry.id}" class="minisbuttontax tax-1">
            <div class="service-icone-box-2">
                <img *ngIf="checkisImg(item.ministry.icon); else elseBlock" src="{{staticURL}}{{item.ministry.icon}}"
                class="img-fluid img-1">
                <ng-template #elseBlock>
                    <i class="{{item.ministry.icon}} p-2" style="font-size: 1rem;"></i>
                </ng-template>
            </div>
            <p class="m-0">{{item.ministry.label}}</p>
        </div>
        <div class="service-date d-flex align-items-center">
            <div class="service-icone-box">
           <i class="pi pi-calendar service-icone"></i>
       </div>
           <div class="d-flex align-items-center">
               <p class="color-grey m-0">{{"Last updated" | translator}}</p>
               &nbsp;&nbsp;&nbsp;
               <p class="color-grey m-0">{{item.updatedAt | date:'MMMM d, y'}}</p>
           </div>
       </div>
    </div>
    <div class="service-desc mb-10 p-2" [innerHTML]="data.data | safeHTML"></div>
</div>